module.exports = __webpack_public_path__ + "img/ic_dorbom_app_logo.92586ba6.png";